import {DG_axios} from "../../../../custom/axios";
import {DG_axiosNormal} from "../../../../custom/axios/normal";


const url = `/dogoo/salary-rest/v2.0/salary-configs`
const urlKeyColumn = `/dogoo/salary-rest/v2.0/salary-configs/key-column`
const urlKeyWork = `/dogoo/salary-rest/v2.0/salary-configs/key-work`
const urlKeyTaskLabel = `/dogoo/task-rest/v2.0/tasks/task-labels`

export async function getAllSalaryConfig(filter
    , page, pageSize, search, sort) {
    const response = await DG_axios.get(
        url
        , {
            params: {
                filter,
                page,
                pageSize,
                search,
                sort
            }
        })
    return response?.data || []
}

export async function getKeyColumn(index) {
    const response = await DG_axios.get(
        urlKeyColumn
        , {
            params: {
                index,
            }
        })
    return response?.data || []
}

export async function getSalaryConfigById(id) {
    const response = await DG_axios.get(url + `/${id}`, null)
    return response?.data || []
}

export async function putSalaryConfig(id, value) {
    const response = await DG_axiosNormal.put(url + `/${id}`, value)
    return response?.data || []
}

export async function postSalaryConfig(value) {
    const response = await DG_axios.post(url, value)
    return response?.data || []
}

export async function deleteSalaryConfig(id) {
    const response = await DG_axios.delete(url + `/${id}`)
    return response?.data || []
}

export async function getKeyword(t){
    const response = await DG_axios.get(urlKeyWork)
    const res =  response?.data
    if(res && t) {
        res.items = res?.items?.map(item => {
            return {
                ...item,
                name: t("layout.keyword." + item?.keyColumn),
                describe: t("layout.keyword." + item?.keyColumn),
                titleColumn: t("layout.keyword." + item?.keyColumn),
                valueColumn: t("layout.keyword." + item?.keyColumn),
            }
        })
    }
    return res || []
};
export async function getAllTaskLabel(){
    const response = await DG_axios.get(urlKeyTaskLabel,{
        params: {
            page: -1,
            pageSize: -1
        }
    })
    return response?.data || []
};

